import { User, USER_TYPES } from '@apply/types';

export const breakpointMap = { lg: 991 };

export const mediaQueryBreakpointMap = { lg: `${breakpointMap.lg}px` };

export const idleTimeout = 1000 * 60 * 60;
export const idleTimerCountdown = 120;
export const spotloanComUrl = 'https://www.spotloan.com';

export const PollInterval = 500;
export const screen7DateFormat = 'MM/dd/yyyy';
export const hasuraDateFormat = 'yyyy-MM-dd';
export const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!@#$%^&*()\-\+=\[\]\{\}|\\;:'"<>,.?/]).{8,64}$/;

export const ConfirmationCodeMedium = {
    Text: 'phone_text',
    Call: 'phone_call',
    Email: 'email',
};

export const addressMaxLength = 50;

export const primaryIncomeSourcePrefix = 'primaryIS';
export const secondaryIncomeSourcePrefix = 'secondaryIS';

export const defaultLoanParameters = {
    [USER_TYPES.NEW]: {
        amount: 600,
        frequency: 'BIWEEKLY',
        payment: 116,
    },
    [USER_TYPES.REPEAT]: {
        amount: 600,
        frequency: 'BIWEEKLY',
        payment: 110,
    },
    [USER_TYPES.PREFERRED]: {
        amount: 600,
        frequency: 'BIWEEKLY',
        payment: 42,
    },
};

export const defaultPaymentPerAmountMap: {
    [K in User['aprType']]: {
        [key: number]: number;
    };
} = {
    [USER_TYPES.NEW]: {
        300: 58,
        400: 77,
        500: 97,
        600: 116,
        700: 136,
        800: 155,
    },
    [USER_TYPES.REPEAT]: {
        300: 55,
        400: 73,
        500: 91,
        600: 110,
        700: 128,
        800: 146,
    },
    [USER_TYPES.PREFERRED]: {
        300: 21,
        400: 28,
        500: 35,
        600: 42,
        700: 49,
        800: 56,
        1000: 70,
        1200: 84,
        1500: 105,
    },
};

export const screen2DataLSName = 'screen2Data';
export const screen3DataLSName = 'screen3Data';
export const localAppData = 'localAppData';
export const queryDataKey = 'queryDataBCF';
export const expirationQueryData = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
export const getStartedData = 'getStartedData';
export const SIGNUP_UTM_SOURCES = ['sendgrid', 'directmail', 'googleads'];

export const countryCodeUsa = '1';

export const LoanStatus = {
    Pending: 'Pending',
    Incomplete: 'Incomplete',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Expired: 'Expired',
} as const;

export const mapBorrowerTypeToAPR = {
    [USER_TYPES.NEW]: 490,
    [USER_TYPES.REPEAT]: 460,
    [USER_TYPES.PREFERRED]: 99,
};

export const NO_RETRY_OPERATIONS = ['sendResetPasswordLink'];

export const COUNT_LIMITS = {
    PAYDAY_LOANS: {
        MIN: 1,
        MAX: 50,
    },
    BANKRUPTCY_FILINGS: {
        MIN: 1,
        MAX: 10,
    },
    HOUSING_EXPENSE: {
        MIN: 0,
        MAX: 100000,
    },
    NUMBER_EVICTIONS: {
        MIN: 1,
        MAX: 10,
    },
};

export const AuthErrors = {
    FatalError: 'fatal_error',
    InvalidClient: 'invalid_client',
    InvalidCode: 'invalid_code',
    UnauthorizedClient: 'unauthorized_client',
    UsernameExists: 'username_exists',
    UserNotFound: 'user_not_found',
    EmailNotFound: 'email_not_found',
    ResetOnCooldown: 'reset_on_cooldown',
    InvalidRequest: 'invalid_request',
    InvalidToken: 'invalid_token',
    ExpiredToken: 'expired_token',
    InvalidPasswordSpec: 'invalid_password_spec',
    BindingCodeAttemptsLimit: 'binding_code_attempts_limit',
    MfaOobLimitExceeded: 'mfa_oob_limit_exceeded',
    MfaChallengesLimitExceeded: 'mfa_challenges_limit_exceeded',
    MissingToken: 'missing_token',
    // this is the expected response for correct login
    MfaRequired: 'mfa_required',
};
export const initialStatusPollingTimespanSec = 90;
export const afterPersonaStatusPollingTimespanSec = 10;
export const appStatusPollingInterval = 2000;
export const minStatusPollingTimespan = 3000;

export const UnprotectedHasuraOperations = [
    'getConfigs',
    'create_application',
    'borrower_login',
    'mfa_challenge',
    'mfa_login',
    'sendResetPasswordLink',
    'checkResetToken',
    'setNewPassword',
    'exchange_token',
    'refreshToken', // TODO - check how refresh_token should behave.
];

export const maintenancePage = {
    title: "We'll be back soon!",
    text: "Sorry for the inconvenience, but we're performing some maintenance at the moment. We'll be back online shortly! Thank you for your patience.",
};

export const PVValidateCodeErrorMsg = {
    bad_code:
        'The code you entered is incorrect. Please check for typos, request a new code, or try using a different phone number.',
    expired_code:
        'The code you entered has expired. Please request a new code.',
    generic: 'There is an error. Please try again later.',
    cooldown: 'Please try again in one minute',
    invalid_phone: 'Please enter a valid phone number',
};

export const leadIdParam = 'leadId';

export const EXPERIMENT_ACH_STORAGE_KEY = 'achVersion';

export const versionKey = 'origination_app_version';

export const VERIFY_PHONE_COOLDOWN_SECONDS = 59;

export const LOAN_DOCUMENTS_EXPERIMENT_STORAGE_KEY =
    'loanDocumentsExperimentVersion';
